import { Icon, Title, Text } from 'components';
import React from 'react';
import styled from 'styled-components';

const StartAConversationEmptyState = () => (
    <StyledContainer>
      <Icon type="newConversation" width={144} height={101} />
      <Title level={3} hideMargin>
        Start a new conversation
      </Title>
      <Text>Select a contact or create a group chat to start chatting</Text>
    </StyledContainer>
  );

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 14px;
  flex: 1;
  height: 100%;
`;

export default StartAConversationEmptyState;
